module.exports = __webpack_public_path__ + "static/media/mobile-bg.6262d2cc.svg";